<div class="retailer-commission-container px-2">
    <div class="section-menu-items">
        <button
        mat-flat-button
        class="item-each"
        [routerLink]="['import']"
        routerLinkActive="router-link-active"
        >
        <span translate class="translate"> pages.newRetailer.importPricelist</span
          ><i class="mi mi-save-alt ms-2"></i>
        </button>    
      </div>
      <router-outlet></router-outlet>
    </div>
    